import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=40497f72&"
import script from "./NavigationDrawer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NavigationDrawer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports